import { render } from "./PzInicio.vue?vue&type=template&id=7273a282"
import script from "./PzInicio.vue?vue&type=script&lang=js"
export * from "./PzInicio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__